module.exports = __webpack_public_path__ + "0cc662bd5762505c2b4c4d3673407242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-5.jpg
// module id = 394
// module chunks = 0